import EditableContainerBase from "Lib/Fs.SmartClient.Client/EditableContainerBase";
import { ValidationRules, ValidationController, ValidationControllerFactory, validateTrigger } from "aurelia-validation";
import { useView, autoinject, Container } from 'aurelia-framework'
import SearchVMBase from "Lib/Fs.SmartClient.Client/SearchVMBase";
import CommonSearchVMBase from "./CommonSearchVMBase";

export default class EditorVMBase extends EditableContainerBase {
    index:number;
    HasOriginalSource: boolean = false;
    OriginalSource: any;

    validationController: ValidationController;
    SetOriginalSource(originalSource) {
        if (originalSource == null)
            this.HasOriginalSource = false;
        else {
            this.OriginalSource = originalSource;
            this.HasOriginalSource = true;
            this.LoadOriginalSource(originalSource);
        }
    }

    constructor() {
        super();
        var self = this;
        var validationControllerFactory = Container.instance.get(ValidationControllerFactory);
        this.validationController = validationControllerFactory.createForCurrentScope();
    }

    Save(doneCallback: () => void, failCallback: (error: any) => void) {

    };

    Remove(searchVM: CommonSearchVMBase, doneCallback: () => void) {

    };

    BeginEdit() {
        this.SetIsEditing(true);
    };

    CancelEdit() {
        if (!this.IsEditing) return;

        this.SetIsEditing(false);
        if (this.HasOriginalSource)
            this.LoadOriginalSource(this.OriginalSource);
    };

    EndEdit() {
        if (!this.IsEditing) return;

        this.SetIsEditing(false);
        var temp = new Object();
        this.SaveOriginalSource(temp);
        this.SetOriginalSource(temp);
        this.FullLoad();
    };

    LoadOriginalSource(originalSource: any) {

    };

    SaveOriginalSource(originalSource: any) {

    };

    FullLoad() {
        if (this.HasOriginalSource)
            super.FullLoad();
    };

    Load(id: string) {

    };

    validateErrors: any[];

  getValidateErrors(key: string) {
    
        if (this.validationController.errors.length == 0) return []
        var filter = this.validationController.errors.filter(function (t) {
            return t.propertyName === key;
        });
        if (filter.length == 0) return [];
        var map = filter.map(function (t) {
            return t.message;
        });
        return map;
    }

    getDisplayNameValidateErrors(key: string) {
        if (this.validationController.errors.length == 0) return []
        var filter = this.validationController.errors.filter(function (t) {
            return t.rule.property.displayName === key;
        });
        if (filter.length == 0) return [];
        var map = filter.map(function (t) {
            return t.message;
        });
        return map;
    }

    ValidateData() {
        this.validationController.validate({ object: this });
    };


  Validate() {
        if (this.validationController.errors.length > 0) {
            return false;
        } else {
            return true;
        }
    }
}
